/** Compatibility export; the business domain owns this implementation. */
export { EnumTrendSorting, EnumTrendTimeField, EnumTrendTimePeriod, EnumTrendType } from '@domains/research/shared';
